/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import nlwkn from '../../assets/nlwkn.jpg';
import DHI from '../../icons/DHI.svg?react';
import { Typography } from '@mui/material';

/* const niedersachsenTopbarStyle = 
  css`
    display: flex;
    height; 60px;
    justify-content: space-between;
    background-color: white;
    width: 100vw;
  `; */

const niedersachsenImageContainerStyle = 
  css`
    display: flex;  
    align-items: center;  
    padding-left: 16px; 
  `;

const nlwknImageStyle = 
  css` 
    background-repeat: no-repeat;
    height: 60px;
    width: 350px;   
  `;

  const dhiImageStyle = 
  css`   
    height: 80px;
    width: 80px;
    padding-right: 16px;
  `;


const NiedersachsenTopbar = () => {
  const nlwknImage = {
    backgroundImage: `url(${nlwkn})`,
  };

  return (
    <div css={niedersachsenImageContainerStyle}><DHI css={dhiImageStyle}/><Typography variant="body2"><b>{" im Auftrag des "}</b></Typography><div css={nlwknImageStyle} style={nlwknImage}/></div>
  )
}

export default NiedersachsenTopbar